<div *ngIf="isCreateView" class="section-page">
    <div class="section-header-bar" [class.section-header-bar--scrolled]="isPageScrolled" *ngIf="currentStep !== 3">
        <div class="section-header">
            <div class="section-header__title">
                <mat-icon class="section-header__icon">group</mat-icon>
                <div>
                    <div class="section-header__heading">Create Agreement - Envelope Recipients</div>
                    <div class="section-header__subtitle">Review who will receive and sign this envelope</div>
                </div>
            </div>
            <div class="section-header__actions">
                <button
                    mat-stroked-button
                    *ngIf="currentStep === 1"
                    (click)="handleSkip()">
                    Skip
                </button>
                <button
                    mat-flat-button
                    class="send-btn"
                    [disabled]="isNextButtonDisabled"
                    (click)="onConfirmRecipient(); handleNext()">
                    Next
                    <mat-icon iconPositionEnd>arrow_forward</mat-icon>
                </button>
            </div>
        </div>
    </div>
    <div *ngIf="!confirmRecipients && currentStep === 1">
        <h5 *ngIf="!isValidDataPanes">Missing information ({{missingInfo}})</h5>
        <div style="display: flex; gap: 15px;">
            <mat-card 
                class="simple-card" 
                style="width: fit-content;" 
                *ngFor="let element of missingData" 
                [ngClass]="{'simple-card-required': element.title?.toLowerCase() !== 'optional'}">
                <mat-card-header>{{element?.title}}</mat-card-header>
                <mat-card-content>
                    <p *ngFor="let field of element.missingFields">
                        {{ field }}
                    </p>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-raised-button (click)="openFormEdit($safeNavigationMigration(element?.title?.toLowerCase()))">Fix</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>

    <div *ngIf="currentStep === 2">
        <!-- <h5>Envelope Recipients</h5> -->
        <div class="generating-preview" *ngIf="isRefreshingData">
            <mat-spinner diameter="30" color="primary"></mat-spinner>
            <p class="loading-text">Loading latest application data...</p>
        </div>
        <app-agreements-recipients
            [hidden]="isRefreshingData"
            [(appData)]="dataModel"
            [(application)]="application"
            (applicationChange)="onApplicationChanged($event)"
            [(currentUser)]="currentUser"
            *ngIf="confirmRecipients"/>
    </div>

    <ng-container *ngIf="currentStep === 3">
        <!-- Preview header: what this is (agreement preview) and where it stands (status badge) -->
        <div class="section-header-bar" [class.section-header-bar--scrolled]="isPageScrolled">
            <div class="section-header">
                <div class="section-header__title">
                    <mat-icon class="section-header__icon">description</mat-icon>
                    <div>
                        <div class="section-header__heading preview-heading">
                            Agreement Preview
                            <span class="status-badge" [ngClass]="'status-badge--' + statusTone">
                                <span class="legend-dot" [ngClass]="'legend-dot--' + statusTone"></span>
                                {{ statusTone | uppercase }}
                            </span>
                        </div>
                        <div class="section-header__subtitle">
                            Loan Agreement<span *ngIf="statusTone === 'draft'"> - Review before sending to recipients</span>
                        </div>
                    </div>
                </div>            </div>
        </div>
        <div class="split-view">
        <div class="pane pane--pdf">                       
            <!-- <span></span> or <div></div> -->
            <!-- <div class="pdf-scroll-container"> -->
                <div *ngIf="pdfSource; else generatingPreview">
                    <ngx-extended-pdf-viewer
                        *ngIf="!isGuideOpen"
                        [src]="pdfSource"
                        [zoom]="'80%'"
                        [showPrintButton]="false"
                        [showDownloadButton]="false"
                        [showOpenFileButton]="false"
                        [showRotateButton]="false"
                        [showSecondaryToolbarButton]="false"
                        [showDrawEditor]="false"
                        [showTextEditor]="false"
                        [showStampEditor]="false"
                        [textLayer]="true"
                        (pdfLoaded)="isPdfLoaded = true"
                        (textLayerRendered)="onTextLayerRendered($event)">
                    </ngx-extended-pdf-viewer>
                </div>
                <ng-template #generatingPreview>
                    <div class="generating-preview">
                        <mat-spinner diameter="30" color="primary"></mat-spinner>
                        <p class="loading-text">{{ loaderText }}</p>
                    </div>
                </ng-template>
            <!-- </div> -->
        </div>
        <div class="pane pane--status" [ngClass]="'pane--status--' + statusTone">
            <div class="status-header">
                <span class="action-link" (click)="onBackToList()">
                <mat-icon>arrow_back</mat-icon>
                    Back to list
                </span>
                <span class="status-header__actions">
                <button *ngIf="!isSent" type="button" class="recipients-toggle"
                    [class.recipients-toggle--active]="showRecipients"
                    [attr.aria-pressed]="showRecipients"
                    (click)="showRecipients = !showRecipients">
                    <mat-icon>{{ showRecipients ? 'close' : 'group' }}</mat-icon>
                    {{ showRecipients ? 'Close recipients' : 'Manage recipients' }}
                </button>
                <mat-icon class="action-icon" *ngIf="isSent" matTooltip="Docusign guide" (click)="openDocusignGuide()">info_outline</mat-icon>
                <mat-icon class="action-icon" *ngIf="isSent" (click)="onRefresh()" matTooltip="Refresh status">refresh</mat-icon>
                </span>
            </div>
            <div *ngIf="!isSent" class="action-bar"
                [class.scrolled-shadow]="isScrolled"
                [class.action-bar--pending]="updateAvailable || missingFields.length || !isDraftReady"
                [class.action-bar--missing]="missingFields.length">
                <div class="action-bar__hint">
                    <mat-icon class="action-bar__hint-icon">{{ missingFields.length ? 'error_outline' : updateAvailable ? 'edit_note' : !isDraftReady ? 'hourglass_empty' : 'check_circle' }}</mat-icon>
                    <span *ngIf="missingFields.length">{{ missingFields.length }} required {{ missingFields.length === 1 ? 'field is' : 'fields are' }} missing.</span>
                    <span *ngIf="!missingFields.length">{{ updateAvailable ? 'You have unsaved changes. Update before sending.' : !isDraftReady ? 'Preparing draft...' : 'Draft is ready to send.' }}</span>
                </div>
                <button mat-flat-button class="send-btn" *ngIf="!updateAvailable && !missingFields.length" [disabled]="!isDraftReady" (click)="onSend()">
                    <mat-icon>send</mat-icon>
                    Send
                </button>
                <button mat-flat-button color="primary" *ngIf="updateAvailable || missingFields.length" [disabled]="isSavingChanges || !updateAvailable || hasClearedRequiredFields" (click)="saveChanges(dataModel)">
                    <mat-spinner *ngIf="isSavingChanges" diameter="16" class="btn-spinner"></mat-spinner>
                    <mat-icon *ngIf="!isSavingChanges">sync</mat-icon>
                    {{ isSavingChanges ? 'Updating...' : 'Update All' }}
                </button>
            </div>

            <div #scrollContainer 
                (scroll)="onScroll(scrollContainer)"
                style="overflow-y: auto; flex: 1; min-height: 0; padding: 0 2px 16px;">
                <ng-container *ngIf="!isSent; else sentMode">
                <!-- Kept mounted with [hidden] so the recipient list and its edits survive toggling -->
                <div class="recipients-view" [hidden]="!showRecipients">
                    <div class="recipients-view__header">
                        <span class="recipients-view__heading">
                            <span class="recipients-view__icon"><mat-icon>group</mat-icon></span>
                            <span class="recipients-view__text">
                                <span class="recipients-view__title">Recipients</span>
                                <span class="recipients-view__subtitle">Delivery channels &amp; signing order</span>
                            </span>
                        </span>
                        <mat-icon class="recipients-view__close" matTooltip="Close recipients" (click)="showRecipients = false">close</mat-icon>
                    </div>
                    <form [formGroup]="recipientForm">
                        <formly-form
                            [form]="recipientForm"
                            [fields]="recipientFields"
                            [model]="dataModel"></formly-form>
                    </form>
                </div>
                <form [formGroup]="formlyForm" [hidden]="showRecipients">
                    <!-- Allow several open panels while required fields are missing, so each one stays revealed -->
                    <mat-accordion [multi]="missingFields.length > 0">
                        <formly-form 
                            [form]="formlyForm" 
                            [fields]="formlyFields" 
                            [model]="dataModel"
                            [options]="options"></formly-form>
                    </mat-accordion>
                </form>
                </ng-container>
                <ng-template #sentMode>
                    <app-agreements-recipient-status 
                        [envelopeId] = "createdEnvelopeId"
                        [appData] = "dataModel"
                        [currentUser] = "currentUser"
                    ></app-agreements-recipient-status>
                </ng-template>
            </div>
        </div>
        </div>
    </ng-container>
</div>
<!-- {{dataModel | json}} -->
<!-- List of agreemenets -->
<div *ngIf="!isCreateView">
    <app-agreements-list 
    [(appData)]="dataModel" 
    [(application)]="application"                     
    (applicationChange)="onApplicationChanged($event)" 
    [(currentUser)]="currentUser"
    (createAgreement)="openCreateRecipientsModal()"/>
</div>

<!-- Create from the list: review recipients in a modal, Next creates the envelope and opens the preview -->
<ng-template #createRecipientsDialog>
    <h2 mat-dialog-title class="create-agreement-title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">Create Agreement</h2>
    <mat-dialog-content>
        <div class="generating-preview" *ngIf="isRefreshingData">
            <mat-spinner diameter="30" color="primary"></mat-spinner>
            <p class="loading-text">Loading latest application data...</p>
        </div>
        <app-agreements-recipients
            [hidden]="isRefreshingData"
            [(appData)]="dataModel"
            [(application)]="application"
            (applicationChange)="onApplicationChanged($event)"
            [(currentUser)]="currentUser"/>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button type="button" mat-dialog-close>Cancel</button>
        <button mat-raised-button color="primary" type="button" (click)="onCreateFromRecipientsModal()" [disabled]="isRefreshingData">Submit</button>
    </mat-dialog-actions>
</ng-template>
    